module.exports = __webpack_public_path__ + "static/media/door.4cbdfb9f.svg";